import React from "react";

export const RedirectAsd = () => {
    const location = window.location;
    if (!location || !location.pathname || location.pathname.includes('i/')) return <div className='weq-loading'></div>

    window.location.href = '/i/' + window.location.pathname;
    return <div className='weq-loading'></div>
};
